module.exports = "../images/icons/alert-info.svg";